@let sepaMandatesItems = sepaMandates$ | async;
@let maxItemsBeforeCollapse = 4;

<div class="container">
  <div class="d-sm-flex justify-content-between">
    <h1>{{ 'user_profile.payment_informations_l' | translate }}</h1>
    <button im-button class="inverted" (click)="editPaymentData()">
      {{ 'account.edit_data_a' | translate }}
    </button>
  </div>

  <hr />

  @if (sepaMandatesItems.length >= maxItemsBeforeCollapse) {
    <a im-button (click)="toggleExpandAll()">
      {{ 'general.expand_all_l' | translate }}
    </a>
  }

  <div class="row gy-4 mt-1">
    @for (item of sepaMandatesItems; track item.contractExternalId) {
      <rs-web-card [elevation]="1" class="col-lg-6 col-12 mr-3">
        <div class="d-flex justify-content-between">
          <h2 class="card-headline">
            {{ ('main_navigation.contract_l' | translate) + ' ' + item.contractExternalId }}
          </h2>

          @if (sepaMandatesItems.length >= maxItemsBeforeCollapse) {
            <rs-web-icon
              rsWebA11yPress
              [focusable]="true"
              [color]="'var(--color-text-primary, #3486ef)'"
              [icon]="
                expandAll || expandElList().includes($index)
                  ? ImmomioIconName.ChevronUp
                  : ImmomioIconName.ChevronDown
              "
              (press)="toggleEl($index)"
            ></rs-web-icon>
          }
        </div>
        @if (
          sepaMandatesItems.length < maxItemsBeforeCollapse ||
          expandAll ||
          expandElList().includes($index)
        ) {
          <div class="d-flex flex-column flex-sm-row justify-content-between p-2">
            <div class="d-flex flex-column mb-sm-3">
              <h3>{{ 'user_profile.escrowed_account_l' | translate }}</h3>
              <span class="primary-text">{{ item.iban || '-' }}</span>
            </div>
            <div class="d-flex flex-column">
              <h3>{{ 'user_profile.sepa_direct_debit_mandate_l' | translate }}</h3>
              @if (item.issuedUntil?.length) {
                <p class="primary-text">
                  {{
                    (item.issuedAt | date: 'dd.MM.yyyy') +
                      ' - ' +
                      (item.issuedUntil | date: 'dd.MM.yyyy')
                  }}
                </p>
              } @else if (item.issuedAt?.length) {
                <p class="primary-text">
                  {{
                    ('user_profile.indefinitely_since_l' | translate) + (item.issuedAt | date) + ')'
                  }}
                </p>
              } @else {
                <p class="primary-text">{{ '-' }}</p>
              }
            </div>
          </div>
        }
      </rs-web-card>
    }
  </div>
</div>
